import { render, staticRenderFns } from "./FolderSetup.vue?vue&type=template&id=a8f08ab4&"
import script from "./FolderSetup.vue?vue&type=script&lang=js&"
export * from "./FolderSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports